import { lazy } from 'react';

// Types
import { ThresholdBarProps as LazyComponentProps } from './ThesholdBar.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "thresholdBar" */ './ThresholdBar')));

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'ThresholdBar');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as ThresholdBar };
